import NamedDto from 'modules/base/dto/NamedDto';

export class AnnModelInputAttributeEditDto extends NamedDto {
	constructor() {
		super();
		/** @type {string} */
		this.type = null;
		/** @type {string} */
		this.uom = null;
		/** @type {string} */
		this.value = null;
		/** @type {string} */
		this.minValue = null;
		/** @type {string} */
		this.maxValue = null;
		/** @type {number} */
		this.orderIndex = null;
	}

	/**
	 * @typedef {Object} _AnnModelInputAttributeEditDtoProps
	 * @property {string} type
	 * @property {string} uom
	 * @property {string} value
	 * @property {string} minValue
	 * @property {string} maxValue
	 * @property {number} orderIndex
	 *
	 * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _AnnModelInputAttributeEditDtoProps} AnnModelInputAttributeEditDtoProps
	 */
	/**
	 *
	 * @param {AnnModelInputAttributeEditDtoProps} props
	 * @returns {AnnModelInputAttributeEditDto}
	 */
	setup(props) {
		super.setup(props);
		this.type = props.type;
		this.uom = props.uom;
		this.value = props.value;
		this.minValue = props.minValue;
		this.maxValue = props.maxValue;
		this.orderIndex = props.orderIndex;
		return this;
	}
}

export default AnnModelInputAttributeEditDto;
